export default __webpack_public_path__ + "static/media/creditoja-banner.a223f3e4.jpg";